import { useState } from "react";
import { KeyRound, Mail, Settings2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { api, apiError } from "@/lib/api";
import { PasswordDialog } from "@/components/settings/backup/PasswordDialog";

const FIELDS = [["daily_hour", "Günlük yedek saati (0-23)"], ["retention_daily", "Günlük yedek saklama (adet)"], ["retention_weekly", "Haftalık yedek saklama (adet)"], ["retention_monthly", "Aylık yedek saklama (adet)"],
  ["s3_retention_daily", "S3 günlük saklama (adet)"], ["s3_retention_weekly", "S3 haftalık saklama (adet)"], ["s3_retention_monthly", "S3 aylık saklama (adet)"]];

export function SettingsCard({ d, onDone }) {
  const [f, setF] = useState(d.settings);
  const [busy, setBusy] = useState(false);
  const [keyOpen, setKeyOpen] = useState(false);
  const [key, setKey] = useState(null);
  const save = async () => {
    setBusy(true);
    try { await api.put("/backup/settings", { ...f, ...Object.fromEntries(FIELDS.map(([k]) => [k, Number(f[k])])) }); toast.success("Yedekleme ayarları kaydedildi"); onDone(); }
    catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  const report = async () => {
    try { const { data } = await api.post("/backup/weekly-report"); toast.success(`Haftalık rapor: ${data.label}`); onDone(); } catch (e) { toast.error(apiError(e)); }
  };
  const reveal = async (password) => {
    try { const { data } = await api.post("/backup/reveal-key", { password }); setKey(data); return true; } catch (e) { toast.error(apiError(e)); return false; }
  };
  return (
    <div className="panel p-4" data-testid="backup-settings-card">
      <h3 className="font-semibold flex items-center gap-2 mb-3"><Settings2 className="h-4 w-4" />Zamanlama & Saklama Politikası</h3>
      <div className="grid grid-cols-2 gap-3">
        {FIELDS.map(([k, label]) => <label key={k} className="text-[12px] text-slate-600">{label}<Input type="number" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`backup-setting-${k}`} /></label>)}
      </div>
      <div className="flex flex-wrap gap-5 mt-3 text-[13px]">
        <label className="flex items-center gap-2"><Switch checked={f.s3_enabled} onCheckedChange={(v) => setF({ ...f, s3_enabled: v })} data-testid="backup-setting-s3" />S3 harici kopya</label>
        <label className="flex items-center gap-2"><Switch checked={f.email_enabled} onCheckedChange={(v) => setF({ ...f, email_enabled: v })} data-testid="backup-setting-email" />Haftalık e-posta</label>
      </div>
      <p className="text-[11px] text-slate-500 mt-2">Varsayılan: yerel 30 günlük / 12 haftalık / 12 aylık · S3 30 günlük / 12 haftalık / 60 aylık (5 yıl). Yerel ve S3 ayrı budanır. Değişiklikler denetim kaydına yazılır.</p>
      <Button className="mt-3" onClick={save} disabled={busy} data-testid="backup-settings-save">Kaydet</Button>
      {d.is_super && <div className="mt-4 pt-3 border-t border-slate-100 flex flex-wrap gap-2">
        <Button size="sm" variant="outline" onClick={report} data-testid="backup-settings-weekly-report-button"><Mail className="h-3.5 w-3.5 mr-1" />Haftalık raporu şimdi oluştur</Button>
        <Button size="sm" variant="outline" onClick={() => setKeyOpen(true)} data-testid="backup-reveal-key-button"><KeyRound className="h-3.5 w-3.5 mr-1" />Şifreleme anahtarını göster</Button>
      </div>}
      {key && <div className="mt-3 rounded border border-amber-300 bg-amber-50 p-3 text-[12px]" data-testid="backup-key-box">
        <div className="font-mono break-all" data-testid="backup-key-value">{key.key}</div>
        <div className="text-amber-800 mt-1">{key.warning}</div>
        <Button size="sm" variant="ghost" className="mt-1" onClick={() => setKey(null)} data-testid="backup-key-hide">Gizle</Button>
      </div>}
      <PasswordDialog open={keyOpen} onOpenChange={setKeyOpen} title="Şifreleme Anahtarını Göster" description="Anahtar olmadan yedekler açılamaz. İşlem denetim kaydına yazılır." confirmLabel="Göster" onConfirm={reveal} />
    </div>
  );
}
